import { render } from "./UserTickets.vue?vue&type=template&id=673302b8&scoped=true"
import script from "./UserTickets.vue?vue&type=script&lang=js"
export * from "./UserTickets.vue?vue&type=script&lang=js"

import "./UserTickets.vue?vue&type=style&index=0&id=673302b8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673302b8"]])

export default __exports__